var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"complete-wrapper"},[_c('img',{staticClass:"w-full",attrs:{"src":require("../../assets/ScanBody/complete.svg")}})])}]

export { render, staticRenderFns }